import React, { useEffect, useState } from "react";
import axios from "axios";
import { IMAGE_URL, URL_API } from "../../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { Modal } from "react-bootstrap";

function EnquiryList() {
  const loaderCss = css`
    margin: auto;
  `;

  const history = useHistory();
  const [enquiry, setEnquiry] = useState([]);
  const [loading, setloading] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showMultipleDelete, setShowMultipleDelete] = useState(false);
  const handleCloseMultipleDelete = () => setShowMultipleDelete(false);
  const handleShowMultipleDelete = () => setShowMultipleDelete(true);
  const [loader, showLoader] = useState(false)
  const [showModal, setShowLoader] = useState(false)
  const handleCloseLoader = () => setShowLoader(false)
  const [filterTitle, setFilterTitle] = useState()
  const [StatusChange, setStatusChange] = useState()
  const [searchStatus, setSearchStatus] = useState(false)
  const [date, setDate] = useState(null)
  const [date2, setDate2] = useState(null)
  const [destroyEnquiryId, setDestroyEnquiryId] = useState(null)
  const [isChecked, setIsChecked] = useState([])
  const [Maker, setMaker] = useState([])
  const [Model, setModel] = useState([])
  const [makerIdForAPi, setMakerIdForAPi] = useState()
  const [modelIdForAPi, setModelIdForAPi] = useState()

  useEffect(() => {
    getEnquiry();
  }, []);



  useEffect(() => {
    setTimeout(() => {
      getServiesData()
      // getCityData()
    }, 500)
  }, [])

  const getServiesData = async () => {
    await fetch(URL_API + 'posts/vehicles')
      .then((responce) => responce?.json())
      .then((data) => {
        setMaker(data?.vehicles)
      })
  }

  const getEnquiry = () => {
    axios.get(URL_API + "auth/admin/car-enquiry-list").then((response) => {
      console.log('enquiry', response);
      if (response.data.status === 200) {
        setEnquiry(response?.data?.enqList);
        setLoadMoreAds(response?.data?.enqList);
      }
    });
  };
  function MakerId(id) {
    if (id) {
      setMakerIdForAPi(id)
      axios
        .post(URL_API + 'posts/vehicle/' + id)
        .then((response) => {
          setModel(response.data.models.vehicle_modles)
        })
        .catch((error) => {
          console.log('error', error)
        })
    }
  }


  function ModelId(id) {
    if (id) {
      setModelIdForAPi(id)
    }
  }

  const destroyEnquiry = (id) => {
    axios
      .post(URL_API + `auth/admin/car-enquiry-delete/${id}`)
      .then((response) => {
        if (response.data.status === 200) {
          history.push("/admin/enquiry");
          toast.success("Enquiry Deleted Successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          });
          getEnquiry();
        }
      });
  };



  const clearFilter = () => {
    getEnquiry()
    let dateField = document.getElementById('title')
    dateField.value = ''
    setFilterTitle('')
    let dateField2 = document.getElementById('date-filter-id')
    dateField2.value = ''
    setDate(null)
    let dateField3 = document.getElementById('date2-filter-id')
    dateField3.value = ''
    setDate2(null)

    let dateField4 = document.getElementById('filter-id-make')
    dateField4.value = ''
    setMakerIdForAPi(null)


    let dateField5 = document.getElementById('filter-id-model')
    dateField5.value = ''

    let dateField6 = document.getElementById('filter-id-status')
    dateField6.value = ''
    setModelIdForAPi(null)

  }

  const onSubmit = () => {
    // if (!loader) {
    //   setLoader(true);
    //   console.log("loader");
    //   setTimeout(() => {
    //     setLoader(false);
    //   }, 10000);
    // }
    // setLoading(true);
    setSearchStatus(true)
    let formData = new FormData()
    if (filterTitle == undefined) {
      formData.append('search', '')
    } else {
      formData.append('search', filterTitle)
    }

    if (StatusChange == undefined) {
      formData.append('status2', '')
    } else {
      formData.append('status2', StatusChange)
    }


    if (makerIdForAPi == undefined) {
      formData.append('vehicle_id', '')
    } else {
      formData.append('vehicle_id', makerIdForAPi)
    }

    if (modelIdForAPi == undefined) {
      formData.append('vehicle_model_id', '')
    } else {
      formData.append('vehicle_model_id', modelIdForAPi)
    }

    if (date == undefined) {
      formData.append('created_at', '')
    } else {
      formData.append('created_at', date)
    }



    if (date2 == undefined) {
      formData.append('to_created_at', '')
    } else {
      formData.append('to_created_at', date2)
    }
    axios
      .post(URL_API + 'auth/admin/car-enquiry-search', formData)
      .then((response) => {
        if (response?.data?.status == 200) {
          if (response?.data?.enqList.length > 0) {
            setEnquiry(response?.data?.enqList)
            setLoadMoreAds(response?.data?.enqList)
          } else {
            toast('No Record Found', {
              showProgressBar: true,
              autoClose: 3000,
              type: 'info',
              position: 'top-right',
            })
          }
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.errors)
      })
  }

  const hanldeCheckBox = (e) => {
    const { value, checked } = e.target
    if (checked) {
      setIsChecked([...isChecked, value])
    } else {
      setIsChecked(isChecked?.filter((e) => e !== value))
    }
  }

  const deleteRecords = async () => {
    setShowMultipleDelete(true)
  }

  const destroyMultipleEnquiries = (destroyMultipleEnquiries) => {
    let formData = new FormData()

    if (isChecked?.length > 0) {
      formData.append('enquiries', isChecked)
    } else {
      setShowMultipleDelete(false)
    }
    axios
      .post(URL_API + 'deleteMultitpleEnquiries', formData)
      .then((response) => {
        if (response?.data?.status == 200) {
          setShowMultipleDelete(false)
          setIsChecked([])
          getEnquiry()
          toast('Records Deleted Successfully', {
            showProgressBar: true,
            autoClose: 3000,
            type: 'success',
            position: 'top-right',
          })
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.errors)
      })
  }


  const initialPostList = 30 // Number of loadMoreAds to display initially
  const incrementInitialPostList = 20 // Number of loadMoreAds to add each time the "load more" button is clicked
  const [displayPosts, setDisplayPosts] = React.useState(initialPostList)
  const [loadMoreAds, setLoadMoreAds] = React.useState()
  const loadMore = () => {
    setDisplayPosts(displayPosts + incrementInitialPostList)
  }


  const [showStatusModal, setShowStatusModal] = useState(false)
  const handleCloseStatus = () => setShowStatusModal(false)
  const handleShowStatus = () => setShowStatusModal(true)
  const [enqueryId, setEnqueryId] = useState(null)
  const [enquiryStatusValue, setEnquiryStatusValue] = useState()


  const onStatusChange = (e, id) => {
    setShowStatusModal(true)
    setEnquiryStatusValue(e?.target?.value)
    console.log('kdkdkdkddkd', e?.target?.value)
    setEnqueryId(id)
  }




  const changeStatusYes = (data) => {
    // showLoader(true)
    setShowStatusModal(false)
    axios
      .post(
        URL_API +
        `auth/admin/enquiryStatusUpdate/${enquiryStatusValue}/${enqueryId}`)
      .then((response) => {
        if (response.data.status === 200) {
          // showLoader(false)

          // reset()
          // history.push('/admin/orders')
          toast.success('Order STATUS Change Successfully', {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          })
          getEnquiry()
        }
      })
  }
  const changeStatusNo = () => {
    setShowStatusModal(false)
    setLoadMoreAds(null)
    getEnquiry()
  }


  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>

              <Table responsive>
                <CardHeader>
                  <CardTitle tag="h4">Car Enquiry</CardTitle>
                </CardHeader>
                {
                  enquiry?.length > 0 && searchStatus == true ? <>
                    <div className="col-lg-4 col-md-4 col-sm-12">
                      <lable className="text-primary">
                        <b>serach result: {enquiry?.length}</b>
                      </lable>&nbsp;Records
                    </div>
                  </> : ''
                }

                {enquiry?.length > 0 && searchStatus == false ? <>
                  <div className="col-lg-4 col-md-4 col-sm-12">
                    <lable className="text-primary">
                      <b>Total: {enquiry?.length}</b>
                    </lable>&nbsp;Records
                  </div>
                </> : ''
                }
                <div
                  style={{
                    paddingLeft: "80%",
                    paddingBottom: "2%",
                    fontSize: "16px",
                  }}
                >
                  <a href={`/admin/maker/create`}>
                    {/* <strong>Add Maker + </strong> */}
                  </a>
                </div>
                <div class="card-header">
                  <div className="col-lg-12 col-md-12 col-sm-12 " style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div className="col-lg-12">
                      <lable className="text-primary">
                        Enter  Name / Phone / Promo Code / Email &nbsp;
                      </lable>
                      <input
                        onChange={(e) => setFilterTitle(e.target.value)}
                        id="title"
                        type="text"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 " style={{ display: 'flex', alignItems: 'flex-end', marginBottom: "10px", marginTop: "20px" }}>
                    <div className="col-lg-6">
                      <lable className="text-primary">
                        Status &nbsp;
                      </lable>
                      <select
                        id="filter-id-status"
                        type="text"
                        className="form-control"
                        onChange={(e) => setStatusChange(e.target.value)}
                      >
                        <option value="">
                          -- Select Status --
                        </option>
                        <option value={''}>Select Status</option>
                        <option value={'Sold Already'}>Sold Already</option>
                        <option value={'Offer Made'}>Offer Made</option>
                        <option value={'Need to follow'}>Need to follow</option>
                        <option value={'Bought'}>Bought</option>
                        <option value={'Good Deal'}>Good Deal</option>
                        <option value={'High Price'}>High Price</option>
                        <option value={'Urgent'}>Urgent</option>
                        <option value={'none'}>None</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 " style={{ display: 'flex', alignItems: 'flex-end', marginBottom: "10px", marginTop: "20px" }}>
                    <div className="col-lg-6">
                      <lable className="text-primary">
                        Select Maker &nbsp;
                      </lable>
                      <select
                        id="filter-id-make"
                        type="text"
                        className="form-control"
                        onChange={(e) => MakerId(e.target.value)}
                      >
                        <option value="">-- Select Maker --</option>
                        {Maker &&
                          Maker.filter(
                            (item) => item?.vehicle_name != 'Other',
                          ).map((item) => (
                            <>
                              <option key={item} value={item?.id}>
                                {item?.vehicle_name}
                              </option>
                            </>
                          ))}

                        {Maker &&
                          Maker?.filter(
                            (item) => item?.vehicle_name == 'Other',
                          )?.map((item) => (
                            <>
                              <option
                                className="btn dropdown-toggle btn-light"
                                key={item}
                                value={item?.id}
                              >
                                {item?.vehicle_name}
                              </option>
                            </>
                          ))}
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <lable className="text-primary">
                        Select Model &nbsp;
                      </lable>
                      <select
                        id="filter-id-model"
                        type="text"
                        className="form-control"
                        onChange={(e) => ModelId(e.target.value)}
                      >
                        <option value="">
                          -- Select Model --
                        </option>
                        {Model.map((val, index) => {
                          return (
                            <option key={index} value={val.id}>
                              {val.modle_name}
                            </option>
                          )
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-sm-12 " style={{ display: 'flex', alignItems: 'flex-end', marginBottom: "10px", marginTop: "20px" }}>

                    <div className="col-lg-6">
                      <label className="text-primary">
                        <b>Select From</b>
                      </label>
                      <input
                        onChange={(e) => setDate(e.target.value)}
                        id="date-filter-id"
                        type="date"
                        className="form-control"
                      />
                    </div>
                    <div className="col-lg-6">
                      <label className="text-primary">
                        <b>Select To</b>
                      </label>
                      <input
                        onChange={(e) => setDate2(e.target.value)}
                        id="date2-filter-id"
                        type="date"
                        className="form-control"
                      />
                    </div>

                  </div>
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12 " style={{ display: 'flex', alignItems: 'flex-end', marginBottom: "10px", marginTop: "20px" }}>

                  <div className="col-lg-12">
                    <button
                      onClick={onSubmit}
                      className="btn btn-primary"
                    >
                      Filter
                    </button>
                    {(filterTitle != '' || date != null || date2 != null || makerIdForAPi != null || modelIdForAPi != null) ?

                      <><button
                        onClick={clearFilter}
                        className="btn btn-danger"
                      >
                        Clear
                      </button></> : ''}


                  </div>
                </div>

              </Table>


              <CardHeader>
                <CardTitle tag="h4">Car Enquiry</CardTitle>
              </CardHeader>
              <div
                style={{
                  paddingLeft: "80%",
                  paddingBottom: "2%",
                  fontSize: "16px",
                }}
              >
                <a href={`/admin/maker/create`}>
                  {/* <strong>Add Maker + </strong> */}
                </a>
              </div>
              <CardBody>

                {
                  isChecked?.length > 0 ?
                    <>
                      <thead>
                        <button className="btn btn-danger" onClick={() => deleteRecords()}>Delete Records</button>
                      </thead>
                    </>
                    : ''
                }


                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th >Name</th>
                      <th style={{ width: "30px" }}>email</th>
                      <th>phone</th>
                      <th>Make</th>
                      <th>Model</th>
                      <th>Year</th>
                      <th>Status</th>

                      <th>Condition</th>
                      {/* <th>Color</th> */}
                      <th>City</th>
                      <th>Milleage</th>
                      {/* <th>Leather Seat</th>
                      <th>Sun Roof</th>
                      <th>Alloy Wheels</th> */}
                      <th>Created At</th>
                      <th>Action</th>
                      {/* <th className="text-right">Salary</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loadMoreAds?.slice(0, displayPosts)?.map(
                      (enqList, index) => {
                        return (
                          <tr style={{
                            backgroundColor:
                              `${enqList?.status2 == 'Sold Already' ? '#fbc8e6'
                                : enqList?.status2 == 'Offer Made' ? '#91c7dc'
                                  : enqList?.status2 == 'Need to follow' ? '#b7ebcc'
                                    : enqList?.status2 == 'Bought' ? '#d4c3fa'
                                      : enqList?.status2 == 'Good Deal' ? '#eebd92'
                                        : enqList?.status2 == 'High Price' ? '#c6e8ee'
                                          : enqList?.status2 == 'Urgent' ? '#ffdbdb' : ''}`
                          }} >
                            <td>{index + 1}</td>
                            <td><div style={{ width: "70px" }}>{enqList?.name === 'undefined' ? '' : enqList?.name}</div></td>
                            <td style={{ width: "70px" }}>{enqList?.email === 'undefined' ? '' : enqList?.email}</td>
                            <td>{enqList?.phone}</td>
                            <td style={{ width: "20px" }} >{enqList?.vehicle?.vehicle_name}</td>
                            <td style={{ width: "70px" }}>{enqList?.vehicle_modle?.modle_name}</td>
                            <td>{enqList?.year === 'undefined' ? '' : enqList?.year}</td>
                            <td style={{ textAlign: "center", fontSize: '15px', fontWeight: 'bold' }}>
                              {enqList?.status2}
                              <select className="btn btn-secondary" onChange={(e) =>
                                onStatusChange(e, enqList?.id)
                              }>
                                <option value={''}>Select Status</option>
                                <option value={'Sold Already'}>Sold Already</option>
                                <option value={'Offer Made'}>Offer Made</option>
                                <option value={'Need to follow'}>Need to follow</option>
                                <option value={'Bought'}>Bought</option>
                                <option value={'Good Deal'}>Good Deal</option>
                                <option value={'High Price'}>High Price</option>
                                <option value={'Urgent'}>Urgent</option>
                                <option value={'none'}>None</option>
                              </select>
                            </td>
                            <td>{enqList?.car_condition_id}</td>
                            <td>{enqList?.city?.select_option}</td>
                            <td>{enqList?.mileage === 'undefined' ? '' : enqList?.mileage}</td>

                            {/* <td>{enqList?.leather_seats == 1 ? 'YES' : 'NO'}</td>
                            <td>{enqList?.sun_roof == 1 ? 'YES' : 'NO'}</td>
                            <td>{enqList?.alloy_wheels == 1 ? 'YES' : 'NO'}</td> */}

                            <td>
                              {moment(enqList?.created_at).format(" DD MMMM,YYYY")}
                            </td>

                            <td>
                              {/* <a style={{color:"#77ac54"}} href={`article/detail/${enqList.id}`}>
                                  <i class="fas fa-eye fa-lg"></i>
                                </a>
                                &nbsp;&nbsp; */}
                              {/* <a href={`maker/edit/${enqList.id}`}>
                                <i class="far fa-edit fa-lg"></i>
                              </a> */}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <a
                                style={{ color: "red" }}
                                onClick={() => destroyEnquiry(enqList.id)}
                              >
                                <i class="fas fa-trash-alt fa-lg"></i>
                              </a>
                            </td>

                          </tr>
                        );
                      }
                      // )
                    )}

                  </tbody>

                </Table>
                {displayPosts < loadMoreAds?.length ? (
                  <div className="container" style={{ textAlign: "center", marginTop: '30px', padding: '10px' }}>
                    <div className="row" >
                      <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="btn-default-section">
                          <button className="btn btn-secondary" onClick={loadMore} style={{ padding: '15px' }}>
                            Load More
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <Modal
        show={showStatusModal}
        onHide={handleShowStatus}
        className="Pop_up"

      >

        <>
          <div className="modalDialog modalConfirm" style={{ textAlign: 'center' }}>
            <div className="modalContent modal-content">
              <div className="modalHeader flex-column">
                <h4 className="modalTitle w-100">Are you sure?</h4>
                {/* <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  &times;
                </button> */}
              </div>
              <div className="modalFooter justify-content-center">
                <button
                  type="submit"
                  class="btn btnSecondary"
                  data-dismiss="modal"
                  onClick={() => changeStatusYes(enquiryStatusValue)}
                >
                  Yes
                </button>
                <button
                  type="button"
                  class="btn btnDanger"
                  onClick={() => changeStatusNo(false)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </>
      </Modal>
    </>
  );
}

export default EnquiryList;
